import {} from '@react-google-maps/api';

const iteratePoints = (geometry: google.maps.LatLng | google.maps.Data | google.maps.Data.Feature | google.maps.Data.Geometry | null, callback: any, thisArg: google.maps.LatLngBounds) => {
	if (geometry instanceof google.maps.LatLng) {
		callback.call(thisArg, geometry);
	} else if (geometry instanceof google.maps.Data.Point) {
		callback.call(thisArg, geometry.get());
	} else {
		// @ts-ignore
		geometry?.getArray().forEach(function (g: any) {
			iteratePoints(g, callback, thisArg);
		});
	}
}

export const getBounds = (features: google.maps.Data): google.maps.LatLngBounds | null => {
	let bounds: google.maps.LatLngBounds | null = null;
	const extendBound = (feature: google.maps.Data.Feature) => {
		if (!bounds) {
			bounds = new google.maps.LatLngBounds()
		}

		const featureObj = feature instanceof google.maps.Data.Feature
			? feature
			: new google.maps.Data.Feature(feature);

		iteratePoints(featureObj.getGeometry(), bounds.extend, bounds);
	};

	features?.forEach((feature) => extendBound(feature));

	return bounds;
}